export function getOriginNameForKegFillsContracteeHistoryTable({
  row,
}) {
  return row.originCustomerName
}
